<template>
  <el-row class="lab-test-table">
    <el-row>
      <er-data-tables
        type="white-header-table"
        v-loading="loading"
        :table-data="tableDataArr"
        :el-table-props="tableProps"
        :action-column="false"
        layout="table"
        uniqueId="lab-test-table"
        :columns="tableColumns"
        :key="$i18n.locale"
      >
        <template v-slot:pond_id_header="{ header }">
          <span>{{ header.label }}</span>
        </template>
        <template v-slot:ph_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:salinity_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:do_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:hardness_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:ammonia_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:iron_header="{ header }">
          <div class="table-col-header-container">
            <p>{{ header.label }}</p>
            <p>{{ header.sub_label }}</p>
          </div>
        </template>
        <template v-slot:pond_id="{ row }">
          <er-select
            v-model="row.data.pond_id"
            size="mini"
            :placeholder="$t('Ponds_select_pond_name')"
          >
            <el-option
              v-for="pond in getPondsInCulture"
              :key="pond._id"
              :value="pond._id"
              :label="pond.title"
            ></el-option>
          </er-select>
        </template>
        <template v-slot:lab_id="{ row }">
          <er-select
            v-model="row.data.lab_id"
            size="mini"
            :placeholder="'Lab Name'"
          >
            <el-option
              v-for="{ _id, title } in getArrLabs"
              :key="_id"
              :value="_id"
              :label="title"
            ></el-option>
          </er-select>
        </template>
        <template v-slot:ph="{ row }">
          <el-input-number
            v-model="row.data.ph"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:salinity="{ row }">
          <el-input-number
            v-model="row.data.salinity"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:do="{ row }">
          <el-input-number
            v-model="row.data.do"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:co3="{ row }">
          <el-input-number
            v-model="row.data.co3"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:hco3="{ row }">
          <el-input-number
            v-model="row.data.hco3"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:alkallnity_total="{ row }">
          <el-input-number
            :value="row.data.co3 + row.data.hco3"
            :controls="false"
            size="mini"
            :disabled="true"
          />
        </template>
        <template v-slot:hardness="{ row }">
          <el-input-number
            v-model="row.data.hardness"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:ammonia="{ row }">
          <el-input-number
            v-model="row.data.ammonia"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:iron="{ row }">
          <el-input-number
            v-model="row.data.iron"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:green_colonies="{ row }">
          <el-input-number
            v-model="row.data.green_colonies"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:yellow_colonies="{ row }">
          <el-input-number
            v-model="row.data.yellow_colonies"
            :controls="false"
            size="mini"
            :min="0"
          />
        </template>
        <template v-slot:actions="{ row }">
          <template v-if="row.$index === tableDataLength - 1">
            <er-button
              btnType="add"
              type="text"
              size="mini"
              :showLabel="true"
              :showIcon="true"
              :disabled="isReadOnly"
              @click="handleAddRow()"
            ></er-button>
          </template>
          <template v-else>
            <er-button
              btnType="delete"
              type="text"
              :showLabel="true"
              :showIcon="true"
              size="mini"
              :disabled="isReadOnly"
              @click="handleDeleteRow(row.$index)"
            ></er-button>
          </template>
        </template>
      </er-data-tables>
      <el-row class="table-footer">
        <er-button
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          :loading="loading"
          size="mini"
          :disabled="isReadOnly"
          @click="handleSaveTableData"
        ></er-button>
        <er-button
          btnType="cancel"
          :showLabel="true"
          size="mini"
          @click="handleCancel"
          :disabled="isReadOnly"
        ></er-button>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
import LabTest from "@/model/labtest";
import { mapGetters, mapActions } from "vuex";

import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import { error } from "highcharts";

export default {
  name: "LabTestsTable",
  mixins: [errorHandlerMixin],
  data: function() {
    return {
      tableDataArr: [new LabTest()],
      tableProps: {
        size: "small"
      },
      permissionsData: {
        name: "labTests",
        keyToValidateAccess: "PERMISSIONS",
        PERMISSIONS: [permissions.MANAGE_LAB_TESTS]
      },
      loading: false,
      labRecords: []
    };
  },
  async mounted() {
    await this.fetchLabTestsByLocation({
      location_id: this.getCurrUserLocation._id,
      date: `${this.getDate}T00:00:00.000Z`,
      get_all: true
    });

    console.log(this.getLocationLabTests);
  },
  watch: {
    async getDate(newDate, oldDate) {
      this.tableDataArr = [new LabTest()];
      console.log(newDate);
      this.initComponent();
    }
  },
  computed: {
    ...mapGetters("pond", {
      getPonds: "getPonds"
    }),
    ...mapGetters("resource", {
      getArrLabs: "getArrLabs",
      isReadOnly: "isReadOnly"
    }),
    ...mapGetters("user", {
      getUserLocations: "getUserLocations",
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZoneOffset: "getUserTimeZoneOffset",
      isReadOnly: "isReadOnly"
    }),
    ...mapGetters("labTests", {
      getDate: "getDate",
      getLocationLabTests: "getLocationLabTests"
    }),
    getMomentObjForSelectedDate: function() {
      const momentISOString = this.$moment
        .utc(this.getDate, "YYYY-MM-DD")
        .toISOString();
      const userISOString = this.$commonUtils.castISOStringToUserTZ(
        momentISOString,
        this.getUserTimeZoneOffset
      );
      const momentObj = this.$moment(userISOString).utcOffset(
        this.getUserTimeZoneOffset
      );
      return this.$lodash.cloneDeep(momentObj);
    },
    getActivePonds() {
      return this.getPonds.filter(({ status }) => status === "ACTIVE");
    },
    getPondsInCulture() {
      return this.getActivePonds.filter(({ cultivation_date }) => {
        return this.$moment(cultivation_date).isBefore(
          this.getMomentObjForSelectedDate
        );
      });
    },
    tableColumns: function() {
      return {
        pond_id: {
          prop: "pond_id",
          label: this.$t("Comn_pond_name"),
          minWidth: 150,
          hasNestedColumns: false,
          align: "center"
        },
        lab_id: {
          prop: "lab_id",
          label: this.$t("Resource_Lab_Name"),
          minWidth: 150,
          hasNestedColumns: false
        },
        ph: {
          prop: "ph",
          label: this.$t("Comn_ph"),
          sub_label: "7.5-8.5",
          minWidth: 100,
          hasNestedColumns: false,
          align: "center"
        },
        salinity: {
          prop: "salinity",
          label: this.$t("Comn_salinity_ppt"),
          sub_label: "15-25",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        do: {
          prop: "do",
          label: this.$t("Comn_do"),
          sub_label: ">3.0",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        co3: {
          prop: "co3",
          label: this.$t("Comn_co3"),
          sub_label: "",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        hco3: {
          prop: "hco3",
          label: this.$t("Comn_hco3"),
          sub_label: "",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        alkallnity_total: {
          prop: "alkallnity_total",
          label: this.$t("Comn_total"),
          sub_label: "",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        hardness: {
          prop: "hardness",
          label: this.$t("Comn_hardness_ppm"),
          sub_label: "300",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        ammonia: {
          prop: "ammonia",
          label: this.$t("Comn_ammonia_nh4_ppm"),
          sub_label: "<1.0",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        iron: {
          prop: "iron",
          label: this.$t("Comn_iron_ppm"),
          sub_label: "<0.1",
          minWidth: 100,
          align: "center",
          hasNestedColumns: false
        },
        green_colonies: {
          prop: "green_colonies",
          label: this.$t("Comn_green_colonies"),
          sub_label: "",
          minWidth: 100,
          hasNestedColumns: false,
          align: "center"
        },
        yellow_colonies: {
          prop: "yellow_colonies",
          label: this.$t("Comn_yellow_colonies"),
          sub_label: "",
          minWidth: 100,
          hasNestedColumns: false,
          align: "center"
        },
        actions: {
          prop: "actions",
          label: this.$t("Comn_actions"),
          minWidth: 80,
          align: "left",
          hasNestedColumns: false
        }
      };
    },
    tableDataLength: function() {
      return this.tableDataArr.length;
    }
  },
  methods: {
    ...mapActions("labTests", {
      addLabTests: "addLabTests",
      fetchLabTestsByLocation: "fetchLabTestsByLocation"
    }),
    async initComponent() {
      await this.fetchLabTestsByLocation({
        location_id: this.getCurrUserLocation._id,
        date: `${this.getDate}T00:00:00.000Z`,
        get_all: true
      });
    },
    async handleCancel() {
      this.tableDataArr = [new LabTest()];
      await this.$emit("reload");
    },
    isRecordAlreadyExisting(currentRecord) {
      let isExitsing = false;
      const sameRecord = this.getLocationLabTests.filter(
        ({ lab_id, pond_id }) => {
          return (
            currentRecord.lab_id === lab_id._id &&
            currentRecord.pond_id === pond_id
          );
        }
      );
      if (sameRecord.length > 0) {
        isExitsing = true;
      }

      return isExitsing;
    },
    getValidationError(record, index) {
      console.log(this.isRecordAlreadyExisting(record));
      if (!record.pond_id) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: this.$t("Comn_pond")
          })} in row ${index + 1}`
        };
      } else if (!record.lab_id) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: this.$t("Comn_lab")
          })} in row ${index + 1}`
        };
      } else if (!record.ph && record.ph != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: "pH"
          })} in row ${index + 1}`
        };
      } else if (!record.salinity && record.salinity != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: this.$t("Comn_salinity")
          })} in row ${index + 1}`
        };
      } else if (!record.do && record.do != 0) {
        return {
          message: `${this.$t("Comn_field_is_required", {
            field: "DO"
          })} in row ${index + 1}`
        };
      } else if (this.isRecordAlreadyExisting(record)) {
        return {
          message: `${this.$t("Comn_record")} ${this.$t(
            "Comn_already exists"
          )} in row ${index + 1}`
        };
      }
    },
    setupPayload() {
      let errors = [];

      let labRecords = this.$lodash.cloneDeep(this.tableDataArr);
      labRecords.forEach((record, index) => {
        record.date = `${this.getDate}T00:00:00.000Z`;
        record.alkallnity_total =
          !record.co3 && record.co3 != 0 && !record.hco3 && record.co3 != 0
            ? 0
            : record.co3 + record.hco3;
        if (this.getValidationError(record, index)) {
          errors.push(this.getValidationError(record, index));
        }
      });

      return {
        labRecords,
        errors
      };
    },
    validatePayload() {
      this.isEditable(this.permissionsData);

      if (this.setupPayload().errors.length > 0) {
        throw {
          type: "FAIL_TO_SAVE",
          errors: this.setupPayload().errors
        };
      } else {
      }
    },
    async handleSaveTableData() {
      this.loading = true;
      let payload = {};
      try {
        this.validatePayload();
        payload = {
          lab_tests: this.setupPayload().labRecords
        };
        await this.addLabTests(payload);
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("Lab_tests_created_success"),
          duration: 5000,
          type: "success"
        });
        this.initComponent();
        this.tableDataArr = [new LabTest()];
      } catch (err) {
        const errors = [];
        console.log(err);
        if (err.errors && err.errors.length > 0) {
          this.errorMessages(err, true);
        } else if (err.response && err.response.data.errors != null) {
          err.response.data.errors.details.forEach((el, index) => {
            errors.push({ message: el.message });
          });
          this.errorFailToSave(errors);
        } else if (err.response && err.response.data.message) {
          errors.push({ message: err.response.data.message });
          this.errorFailToSave(errors);
        } else {
          this.errorMessages(err, true);
        }
      } finally {
        this.loading = false;
      }
    },
    handleAddRow() {
      try {
        this.tableDataArr.push(new LabTest());
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    handleDeleteRow(rowIndexPos) {
      this.tableDataArr.splice(rowIndexPos, 1);
    }
  }
};
</script>
<style lang="scss">
.lab-test-table {
  .table-col-header-container {
    text-align: center;
  }
  .el-table .cell {
    .el-input-number {
      width: 60px;
    }
  }
  .er-data-tables .el-table .el-select {
    width: 130px !important;
  }

  .table-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
}
</style>
